import * as React from "react";

const LogoutIcon = (props) => (
	<svg
		width={25}
		height={24}
		viewBox="0 0 25 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="m12.5 15 3-3m0 0-3-3m3 3h-11m0-4.752V7.2c0-1.12 0-1.68.218-2.108.192-.377.497-.682.874-.874C6.02 4 6.58 4 7.7 4h9.6c1.12 0 1.68 0 2.107.218.377.192.683.497.875.874.218.427.218.987.218 2.105v9.607c0 1.118 0 1.677-.218 2.104a2 2 0 0 1-.875.874c-.427.218-.986.218-2.104.218H7.697c-1.118 0-1.678 0-2.105-.218a2 2 0 0 1-.874-.874C4.5 18.48 4.5 17.92 4.5 16.8v-.05"
			stroke="#fff"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export default LogoutIcon;
